import { FunctionComponent, useEffect, useRef, useState } from "react";
import { RouteComponentProps, useParams, withRouter } from "react-router-dom";
import Select, { MultiValue, SingleValue } from "react-select";
import { ReactSortable } from "react-sortablejs";
import { BaseInfo, Guid, baseUrl } from "../../../api/baseApi";
import { CampaignStatus } from "../../../api/campaingsApi";
import { ChannelMediaModel, ChannelStream, cloneNestedPlaylistMedia, createChannelStream, CreateChannelStreamRequest, createSiteNestedPlayList, deleteChannelStream, deleteSiteNestedPlayList, disableSkinChannelStream, disableSkinNestedPlaylistMedia, enableSkinChannelStream, enableSkinNestedPlaylistMedia, getChannelById, getChannelStreams, getSiteNestedPlayListMedias, getSiteNestedPlayLists, pauseNestedPlaylistMedia, playNestedPlaylistMedia, ReorderItemPair, reorderNestedPlaylists, SiteNestedPlayList, updateChannelStream, updateSiteNestedPlayList, enableSitePlaylistsRandomOrder, disableSitePlaylistsRandomOrder, LocalFile, LocalFileRequest, createLocalFile, updateLocalFile, deleteLocalFile, getLocalFiles, getSiteNestedPlayListMediaLiveStatistic, NestedPlaylistMediaLiveStatistic, getGroupedMedia, GroupMedia, ReorderedIds, reorderGroupMedia, updateGroupForMedia, GroupForMediaRequest, createGroupForMedia, changeGroupName, cloneGroupMedia, removeGroupMedia, getGroupsForMedia, stopLocalFile, pauseLocalFile, playLocalFile, setSpeedLocalFile, restartLocalFile, jumpToLocalFile, shuffleMediaItems, DuplicateMediaInGroupsRequest, duplicateMediaInGroups } from "../../../api/channelsApi";
import { MediaContentType, MediaType, mediaContentTypeOptions } from "../../../api/mediaApi";
import { getTVChannels, TVChannel } from "../../../api/tvChannelApi";
import { addLeadingZero, formatDuration, formatToPercent, renderMediaType, sortByNameString } from "../../../services/common";
import { formatDate, formatTime, formatTimeOnly } from "../../../services/dateService";
import { Button } from "../../components/Button";
import FormCheckbox from "../../components/formRow/FormCheckbox";
import { FormInput, FormInputNumber, FormRow } from "../../components/formRow/FormRow";
import GlobalSpinner from "../../components/globalsSpinner/GlobalSpinner";
import IconButton from "../../components/iconButton/IconButton";
import { RightModal, SmallModal } from "../../components/sideModal/Modal";
import SvgSelector from "../../components/svgSelector/SvgSelector";
import Tabs, { TabElement, TabNavigationElement, TabsContainer } from "../../components/tab/Tab";
import InnerLayout from "../innerLayout/InnerLayout";
import { getTags } from "../../../api/tagApi";
import { getToken } from "../../../api/authApi";
import FormRangeValues from "../../components/formRow/FormRangeValues";
import hiveStackIMG from './../../images/icons/hivestack.jpg';
import { SourceType } from "../../../api/priorityListApi";

interface  ChannelMediaParams{
    channelId: Guid
}

interface ChannelMediaProps extends RouteComponentProps<any>{
    logOut : () => void;
    toogleCollapse: () => void;
    isCollapsed: boolean;
}

type ModalAction = "create" | "update" | "set" | "clone" | "delete" | "nothing" | "shuffle" | "cloneToGroups";
type Option<T> = { value: T, label: string}
interface CheckedItems {
    [key: string]: boolean;
}
 
const ChannelMedia: FunctionComponent<ChannelMediaProps> = (props: ChannelMediaProps) => {
    let {isCollapsed, logOut, toogleCollapse } = props;

    let [isLoading, setIsLoading] = useState<boolean>(false);
    let [medias, setMedias] = useState<ChannelMediaModel[]>([]);
    let [streams, setStreams] = useState<ChannelStream[]>([]);
    let [maxOrder, setMaxOrder] = useState<number>(0);
    let [totalDuration, setTotalDuration] = useState<number>(0);
    let [totalDurationActive, setTotalDurationActive] = useState<number>(0);

    let [showModal, setShowModal] = useState<boolean>(false);
    let [streamName, setStreamName] = useState<string>("");
    let [isStreamNameError, setIsStreamNameError] = useState<boolean>(false);
    let [isStreamStartTimeError, setIsStreamStartTimeError] = useState<boolean>(false);
    let [isStreamEndTimeError, setIsStreamEndTimeError] = useState<boolean>(false);
    let [streamStartTime, setStreamStartTime] = useState<string>("");
    let [streamEndTime, setStreamEndTime] = useState<string>("");
    let [streamId, setStreamId] = useState<Guid>();

    let [currentSite, setCurrentSite] = useState('');

    let [nestedPlayListAction, setNestedPlayListAction] = useState<ModalAction>("nothing");
    
    let [playlistName, setPlaylistName] = useState("");
    let [isPlaylistNameError, setIsPlaylistNameError] = useState(false);
    let [useRandomOrder, setUseRandomOrder] = useState(false);
    let [nestedPlayLists, setNestedPlayLists] = useState<SiteNestedPlayList[]>([]);
    let [activeNestedPlaylistId, setActiveNestedPlayListId] = useState<Guid>("");
    let [isShowNestedPlaylistDeleteModal, setIsShowNestedPlaylistDeleteModal] = useState(false);
    let [playInRandomOrder, setPlayInRandomOrder] = useState(false);

    let [tvChannelsList, setTvChannelsList] = useState<TVChannel[]>([]);
    let [selectedTvChannel, setSelectedTvChannel] = useState<SingleValue<TVChannel>>(null);

    let [localFiles, setLocalFiles] = useState<LocalFile[]>([]);
    let [localFileIdForAction, setLocalFileIdForAction] = useState<Guid>("");
    let [isShowLocalFileModal, setIsShowLocalFileModal] = useState<boolean>(false);
    let [localFileName, setLocalFileName] = useState<string>("");
    let [isLocalFileNameError, setIsLocalFileNameError] = useState<boolean>(false);
    let [localFilePath, setLocalFilePath] = useState<string>("");
    let [isLocalFilePathError, setIsLocalFilePathError] = useState<boolean>(false);
    let [isLocalFileStartTimeError, setIsLocalFileStartTimeError] = useState<boolean>(false);
    let [isLocalFileEndTimeError, setIsLocalFileEndTimeError] = useState<boolean>(false);
    let [localFileStartTime, setLocalFileStartTime] = useState<string>("");
    let [localFileEndTime, setLocalFileEndTime] = useState<string>("");
    let [localFileDelay, setLocalFileDelay] = useState<string>("0");
    let [localFileAction, setLocalFileAction] = useState<ModalAction>("nothing");
    let [isShowLocalFileDeleteModal, setIsShowLocalFileDeleteModal] = useState(false);

    let [liveStatistic, setLiveStatistic] = useState<NestedPlaylistMediaLiveStatistic>();

    let [isShowPausedMedia, setIsShowPausedMedia] = useState(false);

    let [groupedMedia, setGroupedMedia] = useState<GroupMedia[]>([])
    let [isShowGroupModal, setIsShowGroupModal] = useState(false)
    let [mediaGroups, setMediaGroups ] = useState<Option<Guid>[]>([]);
    let [selectedMediaGroup, setSelectedMediaGroup] = useState<Guid>('');
    let [selectedGroupIds, setSelectedGroupIds] = useState<Guid[]>([]);
    let [mediaGroupAction, setMediaGroupAction] = useState<ModalAction>("nothing");
    let [groupName, setGroupName] = useState("");
    let [isGroupNameError, setIsGroupNameError] = useState(false);
    let [isShowGroupConfirmModal, setIsShowGroupConfirmModal] = useState(false);
    let [groupModalAction, setGroupModalAction] = useState<ModalAction>("nothing");
    let [groupIdForAction, setGroupIdForAction] = useState<Guid>("");
    let [mediaIdForAction, setMediaIdForAction] = useState<Guid>("");

    let [tags,setTags] = useState<Option<Guid>[]>([]);
    let [selectedTagIds, setSelectedTagIds] = useState<Guid[]>([]);
    let [checkedItems, setCheckedItems] = useState<CheckedItems>({});
    let [isListCollapsed, setIsListCollapsed] = useState(true)

    let [isShowMiniPlayerBlock, setIsShowMiniPlayerBlock] = useState(false)
    let [playbackSpeedLocalFiles, setPlaybackSpeedLocalFiles ] = useState<{id:Guid, speed:number}[]>([]);
    let [jumpToLocalFiles, setJumpToLocalFiles ] = useState<{id:Guid, timeCode:string}[]>([]);

    let [listHash, setListHash] = useState(0);

    let [isShowFlyDates, setIsShowFlyDates] = useState(false);
    let [checkedFlyDatesItems, setCheckedFlyDatesItems] = useState<CheckedItems>({});

    let [isShowShareOfVoice, setIsShowShareOfVoice] = useState(false);

    let [isShowMediaCategory, setIsShowMediaCategory] = useState(false);

    let [isShowShuffleConfirmModal, setIsShowShuffleConfirmModal] = useState(false)

    let [orderDuplicatedInGroups, setOrderDuplicatedInGroups] = useState<number | string>(1)

    let [rtmpURL, setRtmpURL] = useState<string>("");
    let [isRtmpURLError, setIsRtmpURLError] = useState<boolean>(false);
    let [selectedStreamType, setSelectedStreamType] = useState<SourceType>(SourceType.CapturedStream)

    let { channelId } = useParams<ChannelMediaParams>();
    
    useEffect(() => {
        async function fetchData(){
            setIsLoading(true);
            await Promise.all([
                updateStreams(), 
                updateNestedPlayLists(), 
                getSiteById(), 
                updateTvChannelList(), 
                updateLocalFiles(), 
                updateTags()]);

            setIsLoading(false);
        }

        fetchData();
    }, [])

    useEffect(() =>{
        const initialCheckedItems: CheckedItems = {};
        const initialCheckedFlyDatesItems: CheckedItems = {};

        groupedMedia.forEach(item => {
            initialCheckedItems[item.id] = checkedItems[item.id] ?? true;

            if (item.singleMedia) {
                initialCheckedFlyDatesItems[item.id] = checkedFlyDatesItems[item.id] ?? true;
            } else {
            item.groupMedia?.forEach(subItem => {
                initialCheckedFlyDatesItems[subItem.id] = checkedFlyDatesItems[subItem.id] ?? true;
            });
            }
        });

        setCheckedItems(initialCheckedItems);
        setCheckedFlyDatesItems(initialCheckedFlyDatesItems)
    },[groupedMedia])

    useEffect(() => {
        const allChecked = Object.values(checkedItems).every((checked) => checked);
        if(allChecked) setIsListCollapsed(false)
        else setIsListCollapsed(true)
    },[checkedItems])

    useEffect(()=>{
        const getGroupedMediaAndGroups = async () => {
            await updateGroupedMedia(selectedTagIds);
            await updateGroups();
            await updateNestedPlaylistGroupedMediaLiveStatistic(selectedTagIds);
            }
        if(activeNestedPlaylistId) getGroupedMediaAndGroups();
    },[activeNestedPlaylistId])

    const updateTvChannelList = async () => {
        let response = await getTVChannels();
        if( response.type === "succes") {
            setTvChannelsList(response.data.items);
        }
    }


    const getSiteById = async () => {
        let result = await getChannelById(channelId);
        if(result.type === "succes"){
            setCurrentSite(result.data.name);
            setPlayInRandomOrder(result.data.playInRandomOrder);
        }
    }


    const updateStreams = async () => {
        var streamsResponse = await getChannelStreams(channelId);
        if(streamsResponse.type == "succes"){
            setStreams(streamsResponse.data.items);
        }
    }

    const updateLocalFiles = async () => {
        let response = await getLocalFiles(channelId);
        if( response.type === "succes") {
            setLocalFiles(response.data.items);
            setPlaybackSpeedLocalFiles(response.data.items.map(el => ({id: el.id, speed:1})))
            setJumpToLocalFiles(response.data.items.map(el => ({id: el.id, timeCode:"00:00:00"})))
        }
    }

    const updateGroupedMedia = async ( tagIds: Guid[] = []) => {
        let response = await getGroupedMedia(channelId, activeNestedPlaylistId, tagIds);
        if( response.type === "succes") {
            setGroupedMedia(response.data.items)
            setListHash(response.data.hash)
        }
    }

    const updateGroups = async () => {
        let response = await getGroupsForMedia(channelId, activeNestedPlaylistId);
        if( response.type === "succes") {
            let arr:Option<Guid>[] = []
            response.data.items.forEach( it => {
                arr.push({label: it.name, value: it.id}) 
            })
            setMediaGroups(arr)
        }
    }

    const updateTags = async () => {
        let tagResponse = await getTags();
        if(tagResponse.type == "succes") {
            setTags([
                {
                    label: "No Tags",
                    value: "00000000-0000-0000-0000-000000000000"
                },
                ...tagResponse.data.items.map( t => { return {label:t.name, value:t.id}})
            ])
        }
    }

    const onDropMediaInGroup = async (newOrderedMedia: ChannelMediaModel[], myNum: number) => {
        let arr = [...groupedMedia]
        arr[myNum].groupMedia = newOrderedMedia
        setGroupedMedia(arr)
    }

    const sendReorderedIds = async () => {
        setIsLoading(true)
        setTimeout(async () => {
            await reorderGroupMedia(getReorderedIdsForRequest(groupedMedia), channelId, activeNestedPlaylistId);
            await updateGroupedMedia()
            setIsLoading(false)
        }, 200)
    }

    const onDropPlaylist = async (newOrderedPlaylists: SiteNestedPlayList[]) => {
        let reorderItems : ReorderItemPair[] = [];
        for(let index = 0; index < newOrderedPlaylists.length; index++){
            if(nestedPlayLists[index].id !== newOrderedPlaylists[index].id){
                reorderItems.push({ from: newOrderedPlaylists[index].id, to: nestedPlayLists[index].id});
            }
        }    
        if(reorderItems.length !== 0){
            setIsLoading(true);
            await reorderNestedPlaylists({ reorderItems: reorderItems }, channelId);
            await updateNestedPlayLists();
            setIsLoading(false);
        }
    }

    const clone = async (mediaId: Guid) => {
        setIsLoading(true);
        await cloneNestedPlaylistMedia(channelId, activeNestedPlaylistId, mediaId);
        await updateGroupedMedia()
        await updateNestedPlaylistGroupedMediaLiveStatistic();
        setIsLoading(false);
    }

    const pause = async (mediaId: Guid) => {
        setIsLoading(true);
        await pauseNestedPlaylistMedia(channelId, activeNestedPlaylistId, mediaId);
        await updateGroupedMedia()
        await updateNestedPlaylistGroupedMediaLiveStatistic();
        setIsLoading(false);
    }

    const play = async (mediaId: Guid) => {
        setIsLoading(true);
        await playNestedPlaylistMedia(channelId, activeNestedPlaylistId, mediaId);
        await updateGroupedMedia()
        await updateNestedPlaylistGroupedMediaLiveStatistic();
        setIsLoading(false);
    }

    const enableSkin = async (mediaId: Guid) => {
        setIsLoading(true);
        await enableSkinNestedPlaylistMedia(channelId, activeNestedPlaylistId, mediaId);
        await updateGroupedMedia()
        setIsLoading(false);
    }

    const disableSkin = async (mediaId: Guid) => {
        setIsLoading(true);
        await disableSkinNestedPlaylistMedia(channelId, activeNestedPlaylistId, mediaId);
        await updateGroupedMedia()
        setIsLoading(false);
    }

    const enableSkinStream = async (streamId: Guid) => {
        setIsLoading(true);
        await enableSkinChannelStream(channelId, streamId);
        await updateStreams();
        setIsLoading(false);
    }

    const disableSkinStream = async (streamId: Guid) => {
        setIsLoading(true);
        await disableSkinChannelStream(channelId, streamId);
        await updateStreams();
        setIsLoading(false);
    }

    const deleteStream = async (id: Guid) => {
        await deleteChannelStream(id);
        await updateStreams();
    }

    const closeModal = () => {
        setShowModal(false);
        setStreamName("");
        setIsStreamNameError(false);
        setStreamStartTime("");
        setIsStreamStartTimeError(false)
        setStreamEndTime("");
        setIsStreamEndTimeError(false);
        setStreamId(undefined);
        setSelectedTvChannel(null);
        setSelectedStreamType(SourceType.CapturedStream)
        setRtmpURL("")
        setIsRtmpURLError(false)
    }

    const openModal = (stream: ChannelStream) => {
        setStreamName(stream.name);
        setStreamStartTime(stream.startTime);
        setStreamEndTime(stream.endTime);
        setStreamId(stream.id);
        let currentTvChannel = tvChannelsList.find(it => it.id === stream.tvChannelId)
        setSelectedTvChannel( currentTvChannel ? currentTvChannel : null)
        setSelectedStreamType(stream.sourceType)
        setRtmpURL(stream.rtmpUrl)
        setShowModal(true);
    }

    const renderCampaignStatus = (status: CampaignStatus) => {
        switch(status){
            case CampaignStatus.Active : return <td className="status-active">Active</td>;
            case CampaignStatus.Draft : return <td className="status-draft">Draft</td>;
            case CampaignStatus.Paused : return <td className="status-paused">Paused</td>;
            case CampaignStatus.Scheduled : return <td className="status-scheduled">Scheduled</td>;
            case CampaignStatus.Expired : return <td className="status-expired">Expired</td>;
            default : return <td className="status-null"></td>
        }
        
    }

    const renderStream = (stream: ChannelStream) => {
        return <tr key={stream.id}>
                    <td>{renderStreamType(stream.sourceType)}</td>
                    <td>{stream.name}</td>
                    <td>{formatDate(stream.startTime)} {formatTime(stream.startTime)} </td>
                    <td>{formatDate(stream.endTime)} {formatTime(stream.endTime)}</td>
                    <td>{renderStreamSource(stream)}</td>
                    <td>
                        {stream.isTriggeringSkin 
                            ? <IconButton tooltipText="With Skin" type="mosaic" onClick={() => {disableSkinStream(stream.id)}}/> 
                            : <span className="no-skin-svg-icon">
                                <IconButton tooltipText="No Skin" type="mosaic" onClick={() => {enableSkinStream(stream.id)}}/>
                        </span>}
                        <IconButton tooltipText="Delete" type="delete" onClick={() => deleteStream(stream.id)} />
                        <IconButton tooltipText="Edit" type="edit" onClick={() => openModal(stream)} />
                    </td>
                </tr>
    }

    const saveStream = async () => {
        let isError = false;
        if(streamName === ""){
            setIsStreamNameError(true); isError = true;
        }

        if(streamStartTime === ""){
            setIsStreamStartTimeError(true); isError = true;
        }

        if(streamEndTime === ""){
            setIsStreamEndTimeError(true); isError = true;
        }

        if(selectedStreamType === SourceType.RTMPStream && rtmpURL === ""){
            setIsRtmpURLError(true); isError = true;
        }

        if(isError) return;
        setIsLoading(true);
        var request : CreateChannelStreamRequest = {
            name: streamName,
            endTime: streamEndTime,
            startTime: streamStartTime,
            tvChannelId: selectedTvChannel ? selectedTvChannel.id : null,
            rtmpUrl: rtmpURL,
            sourceType: selectedStreamType
        }

        if(!!!streamId){
            await createChannelStream(request, channelId);
        }
        else{
            await updateChannelStream(request, streamId);
        }
        await updateStreams();
        closeModal();
        setIsLoading(false);
    }

    const renderMediaTypePreview = (media: ChannelMediaModel) => {
        switch(media.mediaType){
            case MediaType.Image : return <img className="sortable__item-img" src={media.previewUrl} alt="" />
            case MediaType.Video : return <img className="sortable__item-img" src={media.previewUrl} alt="" />
            case MediaType.VastUrl : return <SvgSelector title="url" />;
            case MediaType.Youtube : return <img className="sortable__item-img" src={media.previewUrl} alt="" />;
            case MediaType.YoutubeLive : return <img className="sortable__item-img" src={media.previewUrl} alt="" />;
            case MediaType.WebPage : return <SvgSelector title="webview" />;
            case MediaType.HiveStack : return <img className="sortable__item-img" src={hiveStackIMG} alt="" />;
        }
    }

    let getActiveNestedPlayList = () => nestedPlayLists.find(it => it.id == activeNestedPlaylistId);
    const checkActiveTab = (tab: string) => tab === activeNestedPlaylistId;

    const showPlaylistModal = (action: ModalAction) => {
        setNestedPlayListAction(action);
        if(action == "update"){
            var nestedPlayList = getActiveNestedPlayList();
            if(nestedPlayList) {
                setPlaylistName(nestedPlayList.name);
                setUseRandomOrder(nestedPlayList.useRandomOrder)
            }
        }      
    }

    const closePlaylistModal = () => {
        setPlaylistName('');
        setUseRandomOrder(false);
        setIsPlaylistNameError(false);
        setNestedPlayListAction("nothing");
    }

    const createOrUpdatePlaylist = async () => {
        setIsLoading(true);
        if(playlistName === "") {
            setIsPlaylistNameError(true);
            return;
        }
        
        let request = {
            name: playlistName,
            useRandomOrder: useRandomOrder
        };

        if(nestedPlayListAction == "update") {
            await updateSiteNestedPlayList(channelId, activeNestedPlaylistId, request)
        }
        if(nestedPlayListAction == "create"){
            var createResult = await createSiteNestedPlayList(channelId, request);
            if(createResult.type == "succes") {
                setActiveNestedPlayListId(createResult.data.id);
            }           
        }
        
        await updateNestedPlayLists();
        setIsLoading(false);
        closePlaylistModal();
    }    

    const renderNestedPlayListTabs = (nestedPlayLists: SiteNestedPlayList[]) => {
        return nestedPlayLists.map( (it, index) => {
            return <TabNavigationElement key={index} title={it.name} isActive={checkActiveTab(it.id)} onClick={() => { setActiveNestedPlayListId(it.id) }} />
        })
    }

    const updateNestedPlayLists = async () => {
        setIsLoading(true);
        let nestedPlayListResponse = await getSiteNestedPlayLists(channelId);
        if (nestedPlayListResponse.type == "succes") {
            setNestedPlayLists(nestedPlayListResponse.data.items.sort((f, s)=> f.order-s.order));
            let activeNestedPlayList = nestedPlayListResponse.data.items.find(it => it.id == activeNestedPlaylistId);
            if(!activeNestedPlayList){
                if(nestedPlayListResponse.data.items.length){
                    setActiveNestedPlayListId(nestedPlayListResponse.data.items[0].id);
                } 
                else setActiveNestedPlayListId("");
            }          
        }

        setIsLoading(false);
    }

    const updateNestedPlaylistGroupedMediaLiveStatistic = async (tagIds: Guid[] = []) => {
        let response = await getSiteNestedPlayListMediaLiveStatistic(channelId, activeNestedPlaylistId, tagIds);
        if (response.type == "succes") {
            setLiveStatistic({
                scheduled: response.data.data.scheduled,
                live: response.data.data.live
            })
        }
    }

    const showNestedDeleteModal = () => {       
        setIsShowNestedPlaylistDeleteModal(true);
    }

    const closeNestedDeleteModal = () => {       
        setIsShowNestedPlaylistDeleteModal(false)
    }

    const deleteNestedPlaylist = async () => {
        await deleteSiteNestedPlayList(channelId, activeNestedPlaylistId);
        await updateNestedPlayLists();
        closeNestedDeleteModal();
    }

    const setRandomOrderForPlaylists = async (status: boolean) => {
        setIsLoading(true);
        if(status) {
            await enableSitePlaylistsRandomOrder(channelId);
        } else {
            await disableSitePlaylistsRandomOrder(channelId)
        }
        await getSiteById();
        setIsLoading(false);
    }

    const onSelectedTvChannel = (newValue: SingleValue<TVChannel>) => {
        setSelectedTvChannel(newValue);
    }

    const getMediaTotalDurationByContentType = (contentType: MediaContentType) => {
        return medias.filter(it => it.contentType === contentType && !(it.isPaused || it.isPausedInCampaign)).map(it => it.durationMs).reduce((a, b) => a+b, 0)
    }

    const getPercentOfTotal = (total:number, current:number) => {
        let res = Math.round((current/total)*100)
        return <span style={{width: "43px", display:"inline-block"}}>{`(${res}%)`}</span>
    }

    const renderContentType = (contentType:MediaContentType) => {
        switch(contentType){
            case MediaContentType.Ads: return mediaContentTypeOptions[0].name;
            case MediaContentType.ClientContent: return mediaContentTypeOptions[1].name;
            case MediaContentType.SelfContent: return mediaContentTypeOptions[2].name;
            case MediaContentType.Backup: return mediaContentTypeOptions[3].name;
        }
    }

    const showLocalFileModal = (action: ModalAction, localFile?: LocalFile) => {
        setIsShowLocalFileModal(true);
        setLocalFileAction(action);
        if(action === "update" && localFile){
            setLocalFileIdForAction(localFile.id);
            setLocalFileName(localFile.name);
            setLocalFilePath(localFile.path);
            setLocalFileStartTime(localFile.startTime);
            setLocalFileEndTime(localFile.endTime);
            setLocalFileDelay(localFile.subtitlesDelayMs +"")
        }
    }

    const hideLocalFileModal = () => {
        setIsShowLocalFileModal(false);
        setLocalFileAction("nothing");
        setLocalFileIdForAction("");
        setLocalFileName("");
        setIsLocalFileNameError(false)
        setLocalFilePath("");
        setIsLocalFilePathError(false);
        setLocalFileStartTime("");
        setIsLocalFileStartTimeError(false);
        setLocalFileEndTime("");
        setIsLocalFileEndTimeError(false);
    }

    const saveLocalFile = async () => {
        let isError = false;
        if(localFileName === ""){
            setIsLocalFileNameError(true); isError = true;
        }

        if(localFilePath === ""){
            setIsLocalFilePathError(true); isError = true;
        }

        if(localFileStartTime === ""){
            setIsLocalFileStartTimeError(true); isError = true;
        }

        if(localFileEndTime === ""){
            setIsLocalFileEndTimeError(true); isError = true;
        }

        if(new Date(localFileEndTime) < new Date(localFileStartTime)){
            setIsLocalFileEndTimeError(true)
            isError = true
        }

        if(isError) return;
        setIsLoading(true);
        var request : LocalFileRequest = {
            name: localFileName,
            path: localFilePath,
            startTime: localFileStartTime,
            endTime: localFileEndTime,
            subtitlesDelayMs: +localFileDelay
        }

        if(!!!localFileIdForAction){
            await createLocalFile(channelId,request);
        }
        else{
            await updateLocalFile(channelId, localFileIdForAction, request);
        }
        await updateLocalFiles();
        hideLocalFileModal();
        setIsLoading(false);
    }

    const showLocalFileDeleteModal = (id: Guid) => {
        setIsShowLocalFileDeleteModal(true);
        setLocalFileIdForAction(id);
    }

    const closeLocalFileDeleteModal = () => {
        setIsShowLocalFileDeleteModal(false);
        setLocalFileIdForAction("")
    }

    const removeLocalFile = async () => {
        setIsLoading(true);
        await deleteLocalFile(channelId, localFileIdForAction);
        await updateLocalFiles();
        closeLocalFileDeleteModal();
        setIsLoading(false);
    }

    const renderLocalFiles = (file: LocalFile) => {
        return <tr key={file.id}>
                    <td>{file.name}</td>
                    <td>{file.path}</td>
                    <td>{formatDate(file.startTime)} {formatTime(file.startTime)} </td>
                    <td>{formatDate(file.endTime)} {formatTime(file.endTime)}</td>
                    <td style={{width:"35%"}}>
                        <div className={`mini-player__controls ${isShowMiniPlayerBlock && file.id === localFileIdForAction ? "show" : ""}`}>
                            <div className="mini-player__buttons">
                                <IconButton tooltipText="" type="play" onClick={playLocalFileInMiniPlayer} />
                                <IconButton tooltipText="" type="stop-play" onClick={pauseLocalFileInMiniPlayer} />
                                <IconButton tooltipText="" type="stop" onClick={stopLocalFileInMiniPlayer} />
                                <IconButton tooltipText="" type="restart" onClick={restartLocalFileInMiniPlayer} />
                                <input type="time" step={1} value={getJumpToForLocalFile(file.id)} onChange={e => setJumpToForLocalFile(file.id, e.target.value)}/>
                                <IconButton tooltipText="" type="clock" onClick={() => jumpToLocalFileInMiniPlayer(file.id)} />
                            </div>
                            <div className="mini-player__speed-range">
                                <FormRangeValues
                                    id="playbackSpeed-range"
                                    title=""
                                    sign="x"
                                    textPosition="right"
                                    values={[0.25, 0.5, 0.75, 0.8, 0.9, 1, 1.1, 1.25, 1.5, 1.75, 2, 2.5, 3, 4, 6, 8, 12, 16, 32, 48, 64]}
                                    value={getPlayBackSpeedForLocalFile(file.id)}
                                    changeValue={setPlayBackSpeedForLocalFile}
                                    onEndAcion={setSpeedLocalFileInMiniPlayer}
                                />
                            </div>
                        </div>
                        <IconButton tooltipText="Mini Player" type="mini-player" onClick={() => {toggleMiniPlayerBlock(file.id)}} />
                        <IconButton tooltipText="Delete" type="delete" onClick={() => {showLocalFileDeleteModal(file.id)}} />
                        <IconButton tooltipText="Edit" type="edit" onClick={() => {showLocalFileModal("update", file)}} />
                    </td>
                </tr>
    }

    
    let globalMediaIndex = 1
    const renderMedia = (medias: ChannelMediaModel[]) => {
        return medias.map((item) => {
            return <tr className={`sortable__item 
                ${item.isPaused || item.isPausedInCampaign ? "is-paused" : ""}
                ${(isShowPausedMedia) ? '' : 'hide-paused'}
                ${(item.isExcluded) ? 'hide-excluded' : ''}
                `} 
                key={item.id}
                >
                <td>{!item.isExcluded && addLeadingZero(globalMediaIndex++, 2)}</td>
                <td className="preview-cell">
                    {renderMediaTypePreview(item)}
                </td>
                <td>{item.name}</td>
                <td>{renderMediaType(item.mediaType)}</td>
                {isShowMediaCategory ? <td>{item.taxonomiesCategoryName}</td> : <td>{item.campaignName}</td>}
                {renderCampaignStatus(item.campaignStatus)}
                <td>{item.isPausedInCampaign ? "Yes": "No"}</td>
                {isShowShareOfVoice ? <td>{(item.shareOfVoice * 100).toFixed(2)}% ({(item.shareOfVoiceCopy * 100).toFixed(2)}%)</td> : <td>{renderContentType(item.contentType)}</td>}
                <td>{formatDuration(item.durationMs).slice(0,-4)}</td>
                {isShowFlyDates ? <td className="fly-dates-cell">
                    {item.flyDates.map(t => <p key={t.id}>
                        <span>{formatDate(t.start)} - {formatDate(t.end)} </span>
                        {t.startTime && t.endTime && <span>{formatTimeOnly(t.startTime)} - {formatTimeOnly(t.endTime)}</span>}
                    </p>)}

                    {item.flyDates.length > 3 ? <>
                    <label htmlFor={`sm-${item.id}`}>
                        {!!checkedFlyDatesItems[item.id] ? "Show more..." : "Show less..."}
                        &nbsp;&nbsp; <span className="arr"></span></label>
                    <input 
                        id={`sm-${item.id}`} 
                        className="show-more" 
                        type="checkbox" 
                        checked={!!checkedFlyDatesItems[item.id]} 
                        onChange={() => {handleFlyDatesCheckboxChange(item.id)}} 
                    /></> : null}
                    
                </td> : <td>
                    {item.tags.map(t => <p key={t.id}>{t.name}</p>)}
                </td>}
                <td>
                    <IconButton tooltipText="Set Group" type="folder" onClick={() => {showGroupModal("set"); setMediaIdForAction(item.id)}}/>
                    <IconButton tooltipText="Clone to Groups" type="folders" onClick={() => {showGroupModal("cloneToGroups"); setMediaIdForAction(item.id)}}/>
                    {item.isTriggeringSkin 
                        ? <IconButton tooltipText="With Skin" type="mosaic" onClick={() => {disableSkin(item.id)}}/> 
                        : <span className="no-skin-svg-icon">
                            <IconButton tooltipText="No Skin" type="mosaic" onClick={() => {enableSkin(item.id)}}/>
                    </span>}
                    {item.isPaused
                    ? item.isPausedInCampaign ? '' : <IconButton tooltipText="Play" type="play" onClick={() => play(item.id)}/>
                    : item.isPausedInCampaign ? '' : <IconButton tooltipText="Stop" type="stop-play" onClick={() => pause(item.id)} />}
                    <IconButton tooltipText="Clone item" type="copy" onClick={() => clone(item.id)}/>
                </td>
            </tr>
        })
    }

    const getReorderedIdsForRequest = (medias: GroupMedia[]) => {
        let requestObject:ReorderedIds = {ids:[], hash: listHash}

        medias.forEach((elem) => {
            if(elem.singleMedia){
                requestObject.ids.push(elem.id)
            } 
            if(elem.groupMedia) {
                requestObject.ids.push(...elem.groupMedia.map(it => it.id))
            }
        })

        return requestObject
    }

    const showGroupConfirmModal = (id: Guid, action: ModalAction) => {
        setGroupIdForAction(id);
        setGroupModalAction(action)
        setIsShowGroupConfirmModal(true);
    }

    const closeGroupConfirmModal = () => {
        setGroupIdForAction("");
        setGroupModalAction("nothing")
        setIsShowGroupConfirmModal(false);
    }

    const shuffleItemsInGroup = async () => {
        setIsLoading(true)
        await shuffleMediaItems(channelId, activeNestedPlaylistId, groupIdForAction)
        await updateGroupedMedia()
        setIsLoading(false)
        closeGroupConfirmModal()
    }

    const cloneGroup = async () => {
        setIsLoading(true)
        await cloneGroupMedia(channelId, activeNestedPlaylistId, groupIdForAction)
        await updateNestedPlaylistGroupedMediaLiveStatistic()
        await updateGroupedMedia()
        setIsLoading(false)
        closeGroupConfirmModal()
    }

    const deleteGroup = async () => {
        setIsLoading(true)
        await removeGroupMedia(channelId, activeNestedPlaylistId, groupIdForAction)
        await updateNestedPlaylistGroupedMediaLiveStatistic()
        await updateGroups()
        await updateGroupedMedia()
        setIsLoading(false)
        closeGroupConfirmModal()
    }

    const renderGroupMedia = (medias: GroupMedia[]) => {
        return medias.map((item, index) => {

            if(item.singleMedia){
                return renderMedia([item.singleMedia])
            }

            if(item.groupMedia){
                return <>
                    <tr className="no-hover" key={item.id}>
                        <td colSpan={11} className="group-media-block" style={{textAlign:'left', padding:"0 0 15px 30px"}}>
                        <div className="group-title">
                            {item.name}
                            <span style={{marginLeft:10}}>{formatDuration(item.durationScheduled)} / {formatDuration(item.durationLive)}</span>
                            <IconButton tooltipText="Clone" type="copy" onClick={() => showGroupConfirmModal(item.id, "clone")}/>
                            <IconButton tooltipText="Edit" type="edit" onClick={() => showGroupModal("update", item)}/>
                            <IconButton tooltipText="Delete" type="delete" onClick={() => showGroupConfirmModal(item.id, "delete")}/>
                            <IconButton tooltipText="Shuffle" type="shuffle" onClick={() => showGroupConfirmModal(item.id, "shuffle")}/>
                            <div className="d-inline-flex justify-content-end" style={{marginLeft:30}}>
                                <label htmlFor={`group-${item.id}`} className="checkbox-control" >
                                    <input 
                                        id={`group-${item.id}`} 
                                        className="checkbox" 
                                        type="checkbox" 
                                        checked={!!checkedItems[item.id]}
                                        onChange={() => handleCheckboxChange(item.id)}
                                    />
                                    <span className="checkbox-bg"></span>
                                    <span className="checkbox-cursor"></span>
                                </label>
                                <span className="current-status">&nbsp;Expand</span>
                            </div>
                        </div>
                        <ReactSortable
                            disabled={isSortDisabled()}
                            list={item.groupMedia}
                            setList={(newState) => {onDropMediaInGroup(newState, index)}}
                            onEnd={()=>{sendReorderedIds()}}
                            tag="table"
                            className="inner-table fix-inner-columns-in-network-media"
                            filter={'.no-sort'}
                            animation={150}
                            fallbackOnBody={true}
                            swapThreshold={0.65}
                        >
                            {renderMedia(item.groupMedia)}
                        </ReactSortable>
                        </td>
                    </tr>
                </>
            }
        })
    }

    const showGroupModal = (action: ModalAction, item?: GroupMedia) => {
        if(item){
            setGroupName(item.name)
            setGroupIdForAction(item.id)
        }
        setMediaGroupAction(action)
        setIsShowGroupModal(true)
    }

    const hideGroupModal = () => {
        setSelectedMediaGroup("")
        setIsGroupNameError(false)
        setMediaGroupAction("nothing")
        setGroupName("")
        setGroupIdForAction("")
        setMediaIdForAction("")
        setSelectedGroupIds([])
        setOrderDuplicatedInGroups(1)
        setIsShowGroupModal(false)
    }

    const onChangeSelectedMediaGroup = (group: SingleValue<Option<Guid>>) => {
        if(group){
            setSelectedMediaGroup(group.value);
        } else {
            setSelectedMediaGroup('');
        }
    }

    const onChangeMultiSelectedMediaGroup = (groups: MultiValue<Option<Guid>>) => {
        setSelectedGroupIds(groups.map(el => el.value))
    }

    const applyCloneMediaInGroups = async () => {
        let request:DuplicateMediaInGroupsRequest = {
            groupIds: selectedGroupIds,
            hash: listHash,
            order: orderDuplicatedInGroups == "" ? null : +orderDuplicatedInGroups
        }
        setIsLoading(true)
        await duplicateMediaInGroups(request, channelId, activeNestedPlaylistId, mediaIdForAction)
        await updateNestedPlaylistGroupedMediaLiveStatistic()
        await updateGroupedMedia()
        setIsLoading(false)
        hideGroupModal()
    }

    const saveGroupForMedia = async () => {
        let request: GroupForMediaRequest = {
            groupId: selectedMediaGroup ? selectedMediaGroup : null,
            hash: listHash
        }
        setIsLoading(true)
        await updateGroupForMedia(request, channelId, activeNestedPlaylistId, mediaIdForAction)
        await updateNestedPlaylistGroupedMediaLiveStatistic()
        await updateGroupedMedia()
        setIsLoading(false)
        hideGroupModal()
    }

    const createNewGroupForMedia = async () => {
        if(groupName === "") {
            setIsGroupNameError(true);
            return;
        }
        
        let request = {name:groupName};
        setIsLoading(true)
        await createGroupForMedia(request, channelId, activeNestedPlaylistId)
        await updateGroups()
        setIsLoading(false)
        hideGroupModal()
    }

    const updateGroupName = async () => {
        if(groupName === "") {
            setIsGroupNameError(true);
            return;
        }
        
        let request = {name:groupName};
        setIsLoading(true)
        await changeGroupName(request, groupIdForAction, channelId, activeNestedPlaylistId)
        await updateGroups()
        await updateGroupedMedia()
        setIsLoading(false)
        hideGroupModal()
    }

    const onSelectedTag = async (newValue: MultiValue<Option<Guid>>) => {
        if(newValue){
            let newTagIds = newValue.map(el => el.value)
            setSelectedTagIds(newTagIds)
            setIsLoading(true)
            await updateGroupedMedia(newTagIds)
            await updateNestedPlaylistGroupedMediaLiveStatistic(newTagIds)
            setIsLoading(false)
        } else {
            setSelectedTagIds([])
            setIsLoading(true)
            await updateGroupedMedia()
            await updateNestedPlaylistGroupedMediaLiveStatistic()
            setIsLoading(false)
        }
    }

    const handleCheckboxChange = (id: string) => {
        setCheckedItems((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const handleFlyDatesCheckboxChange = (id: string) => {
        setCheckedFlyDatesItems((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const toggleAllCheckboxes = () => {
        const allChecked = Object.values(checkedItems).every((checked) => checked);
        const newCheckedItems: CheckedItems = groupedMedia.reduce((acc, item) => {
            acc[item.id] = !allChecked;
            return acc;
        }, {} as CheckedItems);
        setCheckedItems(newCheckedItems);
        setIsListCollapsed(prev => !prev);
    };

    const createDownloadQueryParamsString = () => {
        if(selectedTagIds.length != 0) {
            return selectedTagIds.map(el => `tagIds=${el}`).join('&') + '&';
        }
        else {
            return ''
        }
    }

    const isSortDisabled = () => {
       return  !!selectedTagIds && selectedTagIds?.length != 0;
    }

    const toggleMiniPlayerBlock = (fileId: Guid) => {
        if (isShowMiniPlayerBlock && localFileIdForAction === fileId) {
          setIsShowMiniPlayerBlock(false);
          setLocalFileIdForAction("");
        } else {
          setIsShowMiniPlayerBlock(true);
          setLocalFileIdForAction(fileId);
        }
    };

    const stopLocalFileInMiniPlayer = async () => {
        setIsLoading(true)
        await stopLocalFile(channelId, localFileIdForAction)
        setIsLoading(false)
    }
    const pauseLocalFileInMiniPlayer = async () => {
        setIsLoading(true)
        await pauseLocalFile(channelId, localFileIdForAction)
        setIsLoading(false)
    }
    const playLocalFileInMiniPlayer = async () => {
        setIsLoading(true)
        await playLocalFile(channelId, localFileIdForAction)
        setIsLoading(false)
    }
    const restartLocalFileInMiniPlayer = async () => {
        setIsLoading(true)
        await restartLocalFile(channelId, localFileIdForAction)
        setIsLoading(false)
    }
    const jumpToLocalFileInMiniPlayer = async (localFileId: Guid) => {
        setIsLoading(true)        
        var timeCode = getJumpToForLocalFile(localFileId);
        await jumpToLocalFile(channelId, localFileIdForAction, timeCode)
        setIsLoading(false)
    }
    const setSpeedLocalFileInMiniPlayer = async () => {
        await setSpeedLocalFile(channelId, localFileIdForAction, {speed: getPlayBackSpeedForLocalFile(localFileIdForAction)})
    }

    const getPlayBackSpeedForLocalFile = (id: Guid) => {
        let index = playbackSpeedLocalFiles.findIndex(el => el.id === id)
        if(index !== -1) {
            return playbackSpeedLocalFiles[index].speed
        } else {
            return 1
        }
    }

    const getJumpToForLocalFile = (id: Guid) => {
        let index = jumpToLocalFiles.findIndex(el => el.id === id)
        if(index !== -1) {
            return jumpToLocalFiles[index].timeCode
        } else {
            return "00:00:00";
        }
    }

    const setPlayBackSpeedForLocalFile = (newSpeed: number) => {
        setPlaybackSpeedLocalFiles(prevState =>
            prevState.map(item =>
            item.id === localFileIdForAction ? { ...item, speed: newSpeed } : item
            )
        );
    };
    
    const setJumpToForLocalFile = (id: Guid, timeCode: string) => {
        setJumpToLocalFiles(prevState =>
            prevState.map(item =>
            item.id === id ? { ...item, timeCode: timeCode } : item
            )
        );
    };

    const goToPlaylist = () => {
        props.history.push(`/channels/${channelId}/nested-playlists/${activeNestedPlaylistId}/days-statistic`);
    }

    const getTitleForGroupModal = (action: ModalAction) => {
        switch(action){
            case "cloneToGroups" :
                return "Duplicate in Groups"
            default : 
                return `${mediaGroupAction.charAt(0).toUpperCase() + mediaGroupAction.slice(1)} Group`
        }
    }

    const onChangeOrderDuplicatedInGroups = (newValue: string) => {
        if(newValue === "" || +newValue < 0 ) setOrderDuplicatedInGroups('')
        else setOrderDuplicatedInGroups(+newValue)
    }

    const onChangeStreamType = (value: SourceType) => {
        setSelectedStreamType(value)
        setRtmpURL("")
        setIsRtmpURLError(false)
        setSelectedTvChannel(null)
    };

    const checkSelectedStreamType = (type: SourceType) => type === selectedStreamType

    const renderStreamType = (stream: SourceType) => {
        switch(stream){
            case SourceType.CapturedStream : return "Captured Stream";
            case SourceType.RTMPStream : return "RTMP Stream";
        }
    }

    const renderStreamSource = (stream: ChannelStream) => {
        switch(stream.sourceType){
            case SourceType.CapturedStream : return stream.tvChannelName;
            case SourceType.RTMPStream : return stream.rtmpUrl;
        }
    }

    return (  
        <><InnerLayout
            isCollapsed={isCollapsed}
            logOut={logOut}
            toogleCollapse={toogleCollapse}
            activeTab="channels">
                <>
                <h1 style={{'paddingTop':'45px'}}>{currentSite}</h1>
                <div className="d-flex justify-content-between align-items-center pt-20">
                        <h3>Streams</h3>
                        <Button color="green"  label="Add Stream" onClick={()=>{setShowModal(true)}} />
                </div>
               
                <table className="table modal-table">
                        <thead>
                            <tr>
                                <td>Type</td>
                                <td>Name</td>
                                <td>Start</td>
                                <td>End</td>
                                <td>Source</td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                            {streams.map(renderStream)}
                        </tbody>
                </table>
                
                <div className="d-flex justify-content-between align-items-center pt-20">
                        <h3>Local Files</h3>
                        <Button color="green" label="Add Local File" onClick={()=>{showLocalFileModal("create")}} />
                </div>
               
                {localFiles.length ? <table className="table modal-table">
                    <thead>
                        <tr>
                            <td>Name</td>
                            <td>Path</td>
                            <td>Start Time</td>
                            <td>End Time</td>
                            <td></td>
                        </tr>
                    </thead>
                    <tbody>
                        {localFiles.map(renderLocalFiles)}
                    </tbody>
                </table>: <p>There are no Local Files</p>}

               

                {nestedPlayLists.length === 0 ? <>
                    <h3 className="pt-50">No Playlists</h3>
                    <div className="d-flex align-items-center">
                        <p>Add new playlist</p> &nbsp;&nbsp;&nbsp;&nbsp;
                        <IconButton tooltipText="Add playlist" type="plus" roundedButton={true} onClick={()=> showPlaylistModal("create")} />
                    </div>
                    </> : <>
                    <h3 className="pt-50">Playlists</h3>
                    <Tabs>
                            <div className="tab-navigation justify-content-between gap15 f-no-wrap">
                            <ReactSortable
                                list={nestedPlayLists}
                                setList={(newState) => {onDropPlaylist(newState)}}
                                tag="div"
                                className="tab-navigation"
                                style={{"border":"none"}}
                            >
                                {renderNestedPlayListTabs(nestedPlayLists)}                               
                            </ReactSortable>

                                <div className="d-flex align-items-center gap15 f-auto-size">
                                    
                                    <IconButton tooltipText="Add playlist" type="plus" roundedButton={true} onClick={()=> showPlaylistModal("create")} />

                                    <div className="d-flex align-items-center">
                                        <FormCheckbox id="playlist-use-random" checked={playInRandomOrder} onChange={setRandomOrderForPlaylists} />
                                        <span className="status-block">
                                            {playInRandomOrder ? <span className="current-status online">&nbsp;Play in Random Order</span> : <span className="current-status offline">&nbsp;Play in Random Order</span>}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        <TabsContainer>
                            <TabElement isActive={true}>
                                <>
                                    <div className="d-flex justify-content-end align-items-center mb-20 w-100">
                                        <Button color="green" label="Create Group" onClick={() => {showGroupModal("create")}} />&nbsp;
                                        <Button color="green" label="Edit" onClick={() => {showPlaylistModal("update")}} />&nbsp;
                                        <Button color="gray" label="Delete" onClick={()=>{showNestedDeleteModal()}} />
                                    </div>

                                    
                                    <div className="d-flex justify-content-end align-items-center w-100">
                                        {liveStatistic ? <div className="media-live-statistic">
                                            <div className="media-live-statistic__row">
                                                <div className=""></div>
                                                <div className=""><b>Scheduled</b></div>
                                                <div className=""><b>Live</b></div>
                                            </div>
                                            <div className="media-live-statistic__row">
                                                <div className=""><b>Campaigns</b></div>
                                                <div className="">{formatDuration(liveStatistic.scheduled.campaignsDurationMs)} ({formatToPercent(liveStatistic.scheduled.campaignsPercentage)})</div>
                                                <div className="">{formatDuration(liveStatistic.live.campaignsDurationMs)} ({formatToPercent(liveStatistic.live.campaignsPercentage)})</div>
                                            </div>
                                            <div className="media-live-statistic__row">
                                                <div className=""><b>Network Content</b></div>
                                                <div className="">{formatDuration(liveStatistic.scheduled.siteContentDurationMs)} ({formatToPercent(liveStatistic.scheduled.siteContentPercentage)})</div>
                                                <div className="">{formatDuration(liveStatistic.live.siteContentDurationMs)} ({formatToPercent(liveStatistic.live.siteContentPercentage)})</div>
                                            </div>
                                            <div className="media-live-statistic__row">
                                                <div className=""><b>Inhouse Content</b></div>
                                                <div className="">{formatDuration(liveStatistic.scheduled.inhouseContentDurationMs)} ({formatToPercent(liveStatistic.scheduled.inhouseContentPercentage)})</div>
                                                <div className="">{formatDuration(liveStatistic.live.inhouseContentDurationMs)} ({formatToPercent(liveStatistic.live.inhouseContentPercentage)})</div>
                                            </div>
                                            <div className="media-live-statistic__row">
                                                <div className=""><b>Others</b></div>
                                                <div className="">{formatDuration(liveStatistic.scheduled.othersDurationMs)} ({formatToPercent(liveStatistic.scheduled.othersPercentage)})</div>
                                                <div className="">{formatDuration(liveStatistic.live.othersDurationMs)} ({formatToPercent(liveStatistic.live.othersPercentage)})</div>
                                            </div>
                                            <div className="media-live-statistic__row">
                                                <div className=""><b>Total</b></div>
                                                <div className="">{formatDuration(liveStatistic.scheduled.total)}</div>
                                                <div className="">{formatDuration(liveStatistic.live.total)}</div>
                                            </div>
                                        </div> : null}
                                    </div>                                  
                                    <div className="d-flex justify-content-end align-items-center gap15 w-100">
                                        <div className="d-flex gap5">
                                        <Button color="green" label={`${isListCollapsed ? "Full List" : "Compact View"}`} onClick={toggleAllCheckboxes}  />     
                                        <Button color="green" label={`${isShowMediaCategory ? "Show Campaign" : "Show Category" }`} onClick={() => {setIsShowMediaCategory(prev => !prev)}}  />     
                                        <Button color="green" label={`${isShowShareOfVoice ? "Show Content Type" : "Show  Media SoV" }`} onClick={() => {setIsShowShareOfVoice(prev => !prev)}}  />     
                                        <Button color="green" label={`${isShowFlyDates ? "Show Tags" : "Show Flight Dates" }`} onClick={() => {setIsShowFlyDates(prev => !prev)}}  />     
                                        <Button color="green" label={`SoV View`} onClick={goToPlaylist}  />                                        
                                        </div>
                                        <div className="d-flex align-items-center gap15" style={{width:300}}>
                                            <label>Tags Filter</label>
                                            <Select 
                                                isDisabled={isShowFlyDates}
                                                className={`w-100`}
                                                options={tags}
                                                classNamePrefix={`select`}
                                                onChange={onSelectedTag} 
                                                isClearable={true}
                                                isMulti={true}
                                            />
                                        </div>

                                        <div className="d-flex justify-content-end">
                                            <FormCheckbox id="hide-paused-media" checked={isShowPausedMedia} onChange={setIsShowPausedMedia} />
                                            <span className="status-block" style={{overflow: 'unset', paddingTop: '3px'}}>
                                                {isShowPausedMedia ? <span className="current-status online">&nbsp;Show paused media</span> : <span className="current-status offline">&nbsp;Show paused media</span>}
                                            </span>
                                        </div>

                                        <div className="export-pos">
                                            <a href={`${baseUrl}file/channels/${channelId}/nested-playlists/${activeNestedPlaylistId}/media/download-csv?${createDownloadQueryParamsString()}token=${getToken()}`} target="_blank" download>Download CSV <IconButton tooltipText="Download" type="export"  /> </a>
                                        </div>      
                                        
                                    </div>

                                    {/* table modal-table media-list-table */}
                                    {/* new-alighned-table */}
                                    {groupedMedia.length !== 0 ? <table className="new-alighned-table">
                                        <colgroup>
                                            <col style={{width:"40px"}} /> 
                                            <col style={{width:"140px"}} /> 
                                            <col style={{width:"170px"}} />
                                            <col />
                                            <col />
                                            <col style={{width:"100px"}} />
                                            <col style={{width:"100px"}}/>
                                            <col />
                                            <col style={{width:"70px"}} />
                                            <col />
                                            <col style={{width:"240px"}} />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td>Name</td>
                                                <td>Type</td>
                                                {isShowMediaCategory ? <td>Media Category</td> : <td>Campaign</td>}
                                                <td>Campaign Status</td>
                                                <td>Paused In Campaign&nbsp;</td>
                                                {isShowShareOfVoice ? <td>Share Of Voice</td> : <td>Content Type</td>}
                                                <td>Duration</td>
                                                {isShowFlyDates ? <td>Flight Dates</td> : <td>Tags</td>}
                                                <td>
                                                   
                                                </td>
                                            </tr>
                                        </thead>
                                        <ReactSortable
                                            disabled={isSortDisabled()}
                                            list={groupedMedia}
                                            setList={(newState) => {setGroupedMedia(newState)}}
                                            onEnd={()=>{sendReorderedIds()}}
                                            tag="tbody"
                                            animation={150}
                                            fallbackOnBody={true}
                                            swapThreshold={0.65}
                                        >
                                            {renderGroupMedia(groupedMedia)}
                                        </ReactSortable>
                                    </table> : <></>
                                    }
                                </>
                            </TabElement>
                            <></>
                        </TabsContainer>
                    </Tabs>
                </>}
                        
                <RightModal  title={!!!streamId ? "Add Stream" : "Edit Stream"} show={showModal} onRequestClose={closeModal} >
                     <FormRow>
                            <div className="d-flex gap15">
                            <label>
                                <input
                                    type="radio"
                                    name="pStremType"
                                    value={SourceType.CapturedStream}
                                    checked={selectedStreamType === SourceType.CapturedStream}
                                    onChange={() => onChangeStreamType(SourceType.CapturedStream)}
                                    disabled={!!streamId}
                                />&nbsp;
                                Captured Stream
                            </label>
    
                            <label>
                                <input
                                    type="radio"
                                    name="pStremType"
                                    value={SourceType.RTMPStream}
                                    checked={selectedStreamType === SourceType.RTMPStream}
                                    onChange={() => onChangeStreamType(SourceType.RTMPStream)}
                                    disabled={!!streamId}
                                />&nbsp;
                                RTMP Stream
                            </label>
                            </div>
                        </FormRow>
                    <FormRow>
                        <FormInput 
                            errorMessage = "Please enter name"
                            id = "stream_name_input"
                            isError = {isStreamNameError}
                            title = "Stream Name"
                            onChangeValue = {(v) => {setStreamName(v); setIsStreamNameError(false)}}
                            value = {streamName}
                        />
                    </FormRow>
                    <FormRow>
                        <FormInput
                        errorMessage="Please select Start Time"
                        id="stream_start_time"
                        isError={isStreamStartTimeError}
                        type="datetime-local"
                        onChangeValue={(v) => {setIsStreamStartTimeError(false); setStreamStartTime(v)}}
                        value={streamStartTime}
                        title="Start Time"
                        />                         
                    </FormRow>
                    <FormRow>
                            <FormInput
                            errorMessage="Please select End Time"
                            id="stream_end_time"
                            isError={isStreamEndTimeError}
                            type="datetime-local"
                            onChangeValue={(v) => {setIsStreamEndTimeError(false); setStreamEndTime(v)}}
                            value={streamEndTime}
                            title="End Time"
                            />           
                    </FormRow>    
                    {checkSelectedStreamType(SourceType.CapturedStream) && <FormRow>
                        <label>TV Channel </label>
                        <Select 
                            className={``}
                            classNamePrefix={`select`}
                            isClearable={true}
                            options={tvChannelsList.sort((a,b) => sortByNameString(a.name, b.name))} 
                            filterOption={(option, input)=> option.label.toLowerCase().includes(input.toLowerCase())}
                            getOptionLabel={(option) => `${option.name}`}
                            getOptionValue={(option)=> `${option.id}`}
                            onChange={onSelectedTvChannel}
                            value={selectedTvChannel}
                        />    
                    </FormRow>}
                    {checkSelectedStreamType(SourceType.RTMPStream) && <FormRow>
                        <FormInput 
                            errorMessage = "RTMP"
                            id = "rtmp_url_input"
                            isError = {isRtmpURLError}
                            title = "RTMP URL"
                            onChangeValue = {(v) => {setRtmpURL(v); setIsRtmpURLError(false)}}
                            value = {rtmpURL}
                        />
                    </FormRow>}               
                    <div className="modal-btn-group">
                        <Button color="green" label="Save" onClick={saveStream}/>
                        <Button color="gray" label="Cancel" onClick={closeModal}/>
                    </div>
                </RightModal>   

                <RightModal title={`${localFileAction === "create" ? "Add" : "Edit"} Local File`} show={isShowLocalFileModal} onRequestClose={hideLocalFileModal} >
                    <FormRow>
                        <FormInput 
                            errorMessage = "Please enter name"
                            id = "local_file_name_input"
                            isError = {isLocalFileNameError}
                            title = "Name"
                            onChangeValue = {(v) => {setLocalFileName(v); setIsLocalFileNameError(false)}}
                            value = {localFileName}
                        />
                    </FormRow>
                    <FormRow>
                        <FormInput 
                            errorMessage = "Please enter path"
                            id = "local_file_path_input"
                            isError = {isLocalFilePathError}
                            title = "File name (in the folder 'CPlayerLocalFiles')"
                            onChangeValue = {(v) => {setLocalFilePath(v); setIsLocalFilePathError(false)}}
                            value = {localFilePath}
                        />
                    </FormRow>
                    <FormRow>
                        <FormInput
                            errorMessage="Please select Start Time"
                            id="local_file_start_time"
                            isError={isLocalFileStartTimeError}
                            type="datetime-local"
                            onChangeValue={(v) => {setIsLocalFileStartTimeError(false); setLocalFileStartTime(v)}}
                            value={localFileStartTime}
                            title="Start Time"
                        />                         
                    </FormRow>
                    <FormRow>
                        <FormInput
                            errorMessage="Please select End Time, End Time shoud be later than Start Time"
                            id="local_file_start_time"
                            isError={isLocalFileEndTimeError}
                            type="datetime-local"
                            onChangeValue={(v) => {setIsLocalFileEndTimeError(false); setLocalFileEndTime(v)}}
                            value={localFileEndTime}
                            title="End Time"
                        />           
                    </FormRow>  

                    <FormRow>
                        <FormInput 
                            type="number"
                            errorMessage = ""
                            id = "delay"
                            isError = {false}
                            title = "Subtitles Delay MS"
                            onChangeValue = {(v) => {setLocalFileDelay(v)}}
                            value = {localFileDelay}
                        />
                    </FormRow>  
                                      
                    <div className="modal-btn-group">
                        <Button color="green" label="Save" onClick={saveLocalFile}/>
                        <Button color="gray" label="Cancel" onClick={hideLocalFileModal}/>
                    </div>
                </RightModal>   

                <RightModal title="Add Playlist" show={nestedPlayListAction !== "nothing"} onRequestClose={closePlaylistModal}>
                    <FormRow>
                        <FormInput 
                            errorMessage = "Please enter Playlist Name"
                            id = "playlist_name_input"
                            isError = {isPlaylistNameError}
                            title = "Playlist Name"
                            onChangeValue = {(v) => {setPlaylistName(v); setIsPlaylistNameError(false)}}
                            value = {playlistName}
                        />
                    </FormRow>
                    <FormRow>
                        <div className="d-flex align-items-center">
                            <FormCheckbox id="use-random" checked={useRandomOrder} onChange={setUseRandomOrder} />
                            <span className="status-block">
                                {useRandomOrder ? <span className="current-status online">&nbsp;Play in Random Order</span> : <span className="current-status offline">&nbsp;Play in Random Order</span>}
                            </span>
                        </div>
                    </FormRow>
                    <div className="modal-btn-group">
                        <Button color="green" label="Save" onClick={createOrUpdatePlaylist}/>
                        <Button color="gray" label="Cancel" onClick={closePlaylistModal}/>
                    </div>
                </RightModal> 

                <RightModal title={getTitleForGroupModal(mediaGroupAction)} show={isShowGroupModal} onRequestClose={hideGroupModal}>
                    <FormRow>
                        {mediaGroupAction === "set" && <><label>Groups</label>
                        <Select 
                            options={mediaGroups}
                            classNamePrefix={`select`}
                            onChange={onChangeSelectedMediaGroup} 
                            isClearable={true}
                        /></>}
                        {mediaGroupAction === "cloneToGroups" && <>
                        <label>Groups</label>
                        <Select 
                            options={mediaGroups}
                            classNamePrefix={`select`}
                            onChange={onChangeMultiSelectedMediaGroup} 
                            isClearable={true}
                            isMulti
                        />
                        </>}

                        {(mediaGroupAction === "create" || mediaGroupAction === "update") && <FormInput 
                            errorMessage = "Please enter Group Name"
                            id = "media_group_name"
                            isError = {isGroupNameError}
                            title = "Group Name"
                            onChangeValue = {(v) => {setGroupName(v); setIsGroupNameError(false)}}
                            value = {groupName}
                        />}
                    </FormRow>
                    {mediaGroupAction === "cloneToGroups" && <FormRow>
                        <FormInputNumber 
                            errorMessage = ""
                            id = "order_duplicated"
                            isError = {false}
                            title = "Order"
                            min={1}
                            onChangeValue = {onChangeOrderDuplicatedInGroups}
                            onChange={()=>{}}
                            value = {orderDuplicatedInGroups}
                        />
                    </FormRow>}
                    <div className="modal-btn-group">
                        {mediaGroupAction === "set" && <Button color="green" label="Save" onClick={saveGroupForMedia}/>}
                        {mediaGroupAction === "update" && <Button color="green" label="Save" onClick={updateGroupName}/>}
                        {mediaGroupAction === "create" && <Button color="green" label="Add" onClick={createNewGroupForMedia}/>}
                        {mediaGroupAction === "cloneToGroups" && <Button color="green" label="Save" onClick={applyCloneMediaInGroups}/>}
                        <Button color="gray" label="Cancel" onClick={hideGroupModal}/>
                    </div>
                </RightModal>  

                <SmallModal show={isShowNestedPlaylistDeleteModal} onRequestClose={closeNestedDeleteModal}> 
                    <p>That you want to delete Playlist <b>{getActiveNestedPlayList()?.name}</b>?</p>
                    <div className="modal-btn-group">
                        <Button color="gray" label="Cancel" onClick={closeNestedDeleteModal}/>
                        <Button color="green" label="Yes" onClick={deleteNestedPlaylist}/>
                    </div>
                </SmallModal>

                <SmallModal show={isShowLocalFileDeleteModal} onRequestClose={closeLocalFileDeleteModal}> 
                    <p>That you want to delete Local File?</p>
                    <div className="modal-btn-group">
                        <Button color="gray" label="Cancel" onClick={closeLocalFileDeleteModal}/>
                        <Button color="green" label="Yes" onClick={removeLocalFile}/>
                    </div>
                </SmallModal>

                <SmallModal show={isShowGroupConfirmModal} onRequestClose={closeGroupConfirmModal}> 
                    {groupModalAction === "clone" && <p>That you want to {`${groupModalAction}`} Group?</p>}
                    {groupModalAction === "delete" && <p>That you want to {`${groupModalAction}`} Group?</p>}
                    {groupModalAction === "shuffle" && <p>That you want to shuffle media items?</p>}
                    <div className="modal-btn-group">
                        <Button color="gray" label="Cancel" onClick={closeGroupConfirmModal}/>
                        {groupModalAction === "clone" && <Button color="green" label="Yes" onClick={cloneGroup}/>}
                        {groupModalAction === "delete" && <Button color="green" label="Yes" onClick={deleteGroup}/>}
                        {groupModalAction === "shuffle" && <Button color="green" label="Yes" onClick={shuffleItemsInGroup}/>}
                    </div>
                </SmallModal>

                <GlobalSpinner isShow={isLoading}/>
                </>
        </InnerLayout>
        </>
    );
}
 
export default withRouter(ChannelMedia);

function getTvChannels() {
    throw new Error("Function not implemented.");
}
